import React, {useContext} from 'react';

import {LibrosContext} from '../Context/LibrosProvider';
import MostrarAutor from './MostrarAutor';

const Libros = () => {

    const {libros} = useContext(LibrosContext)

    return (
        <div className="mt-5">
            <h3>Lista de libros</h3>
            <ul className="list-group">
                {
                    libros.map(libro => (
                        <li className="list-group-item" key={libro.id}>
                            <span className="lead text-uppercase text-primary">
                                {libro.titulo} {} - {}
                            </span>
                            <span>
                                Pág:  {libro.paginas} - Autor: {}
                                <MostrarAutor  referencia={libro.autor} id={libro.id}/>
                            </span>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default Libros
